import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import { toast } from "react-toastify";
import HeaderWithButton from "../../Utility/HeaderWithButton";
import { PencilSquareIcon, XMarkIcon } from "@heroicons/react/20/solid";
import { Tooltip } from "react-tooltip";
import DeleteConfirmation from "../../Utility/DeleteConfirmation";
import { Dialog } from "@headlessui/react";
import { DataContext } from "../../../helper/HelperOne";
import { Pagination } from "../../../helper/HelperTwo";

function StatusList() {
  const user = JSON.parse(localStorage.getItem("user"));
  const leadStatusPermission = user?.settings_role_based_access?.some(
    (access) => access.label_id == 7 && access.label_value != 0
  );

  const { searchData } = useContext(DataContext);

  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [leadStatusButton, setLeadStatusButton] = useState("save");
  const [statusData, setStatusData] = useState([]);
  const [editDepartment, setEditDepartment] = useState("");
  const [errors, setErrors] = useState("");
  const [editId, setEditId] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [paginationDatasForLeadStatus, setPaginationDatasForLeadStatus] =
    useState([]);
  const [leadStatus, setLeadStatus] = useState({
    name: "",
  });

  const fetchStatus = async (page = 1) => {
    const token = localStorage.getItem("token");
    if (!token) {
      toast.error("Authorization token is missing");
      return;
    }

    try {
      const leadStatusUrl = searchData
        ? `public/api/admin/leadstatus/pagination?page=${page}&search=${encodeURIComponent(
            searchData
          )}`
        : `public/api/admin/leadstatus/pagination?page=${page}`;

      const response = await axios.get(`${leadStatusUrl}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
   

      setStatusData(response.data.leadstatus.data);
      setPaginationDatasForLeadStatus(response.data.leadstatus);
    } catch (error) {
      console.error("Error fetching department types:", error);
      // toast.error("Failed to fetch department types");
    }
  };

  useEffect(() => {
    fetchStatus();
  }, []);

  useEffect(() => {
    fetchStatus(currentPage);
  }, [searchData, currentPage]);

  const handleAddStatus = () => {
    setLeadStatusButton("save");
    setLeadStatus({ department: "" });
    setIsDialogOpen(true);
  };

  const handleChangeForStatus = (e) => {
    setLeadStatus({
      ...leadStatus,
      [e.target.name]: e.target.value,
    });
  };

  const handleSaveStatus = async (e) => {
    e.preventDefault();
    const token = localStorage.getItem("token");
    if (!token) {
      toast.error("Authorization token is missing");
      return;
    }

    try {
      const response = await axios.post(
        "public/api/admin/leadstatus/store",
        leadStatus,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );


      setIsDialogOpen(false);
      setErrors();
      toast.success("department type added successfully");
      fetchStatus();
    } catch (error) {
      console.error("Error adding department type:", error);
    }
  };

  const handleEditStatus = async (id_crypt) => {

    setIsDialogOpen(true);
    setEditId(id_crypt);
    setLeadStatusButton("update");

    const token = localStorage.getItem("token");
    if (!token) {
      toast.error("Authorization token is missing");
      return;
    }

    try {
      const response = await axios.get(
        `public/api/admin/leadstatus/edit/${id_crypt}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );


      const statusData = response.data.lead_status;
      setLeadStatus({ name: statusData.name });

      setIsDialogOpen(true);
    } catch (error) {
      console.error("Error fetching department type:", error);
      // toast.error("Failed to fetch department type for editing");
    }
  };

  const handleUpdateStatus = async (e) => {
    e.preventDefault();

    const token = localStorage.getItem("token");

    try {
      const response = await axios.put(
        `public/api/admin/leadstatus/update/${editId}`,
        leadStatus,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );


      setIsDialogOpen(false);
      toast.success("Lead Status  updated successfully");
      await fetchStatus();
    } catch (error) {
      console.error(
        "Error updating department type:",
        error.response ? error.response.data : error
      );
      // toast.error("Failed to update department type");
    }
  };

  const handlePageChange = async (page) => {
    if (page !== "..." && !isNaN(page)) {
      const newPage = Number(page);

      setCurrentPage(newPage);
      await fetchStatus(newPage);
    }
  };

  return (
    <>
      <HeaderWithButton
        title="Lead Status"
        description="status"
        buttonText="Status"
        onButtonClick={handleAddStatus}
        showButton={leadStatusPermission}

      />

<div className="grid grid-cols-1 gap-4 items-start sm:items-center w-full">
  <div className="mt-6 overflow-hidden rounded-lg shadow overflow-x-auto">
    <table className="min-w-full divide-y divide-gray-200">
      <thead className="bg-gray-50">
        <tr>
        <th className="py-3 px-5 border-b text-center  text-sm sm:text-base font-normal">
            S No
          </th>
          <th className="py-3 px-5 border-b text-center  text-sm sm:text-base font-normal">
            Status Name
          </th>
          <th className="py-3 px-5 border-b text-center  text-sm sm:text-base font-normal">
            Actions
          </th>
        </tr>
      </thead>
      <tbody className="bg-white divide-y divide-gray-200">
        {paginationDatasForLeadStatus?.data?.map((status, index) => (
          <tr key={index}>
             <td className="px-6 py-4 whitespace-nowrap text-center text-sm  font-medium">
              {paginationDatasForLeadStatus.from + index}
            </td>
            <td className="px-6 py-4 whitespace-nowrap text-center text-sm text-gray-500">
              {status.name}
            </td>
            <td className=" px-6 py-4 whitespace-nowraptext-right text-sm font-medium flex justify-center">
              {leadStatusPermission && 
                 <button
                 className="my-anchor-edit bg-green-400 text-white text-sm py-1 px-2 rounded mr-2 transition duration-200"
                 onClick={() => handleEditStatus(status.id_crypt)}
               >
                 <PencilSquareIcon className="h-5 w-5 text-white" />
                 <Tooltip
                   anchorSelect=".my-anchor-edit"
                   place="top"
                   className="text-xs p-0"
                   style={{
                     fontSize: "12px",
                     padding: "0.3rem",
                   }}
                 >
                   Edit
                 </Tooltip>
               </button>
              }
             
              {leadStatusPermission &&
                <DeleteConfirmation
                id_crypt={status.id_crypt}
                apiType={"leadStatus"}
                fetchClientData={fetchStatus}
              />
              }
            
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
</div>

{isDialogOpen && (
          <Dialog
            open={isDialogOpen}
            onClose={() => {}}
            className="relative z-10"
          >
            <Dialog.Overlay className="fixed inset-0 bg-gray-500 bg-opacity-50 backdrop-blur-sm transition-opacity" />
            <div className="fixed inset-0 z-10 overflow-y-auto">
              <div className="flex min-h-full items-center justify-center p-4 text-center sm:p-0">
                <Dialog.Panel className="my-auto relative bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all w-full sm:w-full md:max-w-screen-sm lg:max-w-screen-xl h-full sm:h-auto max-h-[90vh] overflow-y-auto">
                  <div
                    className="flex justify-between items-center mb-4 bg-gray-200 p-4"
                    style={{ backgroundColor: "#6366f1" }}
                  >
                    <h1 className=" text-white mx-auto sm:px-6 sm:mx-0 md:px-8 sm:text-lg font-medium mb-2 uppercase z-100">
                      Lead Status
                    </h1>
                    <button
                      type="button"
                      onClick={() => setIsDialogOpen(false)}
                    >
                      <XMarkIcon
                        className="h-6 w-6 sm:h-8 sm:w-8 text-white cursor-pointer"
                        aria-hidden="true"
                      />
                    </button>
                  </div>
                  <div className="w-full max-w-7xl mx-auto p-6 bg-gray-50">
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
                      <div className="sm:col-span-2">
                        <form>
                          <div className="overflow-hidden sm:rounded-md">
                            <div className="space-y-4">
                              <div>
                                <label
                                  htmlFor="department"
                                  className="block text-sm font-medium leading-6 text-gray-900"
                                >
                                  Name
                                </label>
                                <div className="mt-2">
                                  <input
                                    name="name"
                                    type="text"
                                    value={leadStatus.name}
                                    onChange={handleChangeForStatus}
                                    autoComplete="mode"
                                    className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                                  />
                                </div>
                                {errors && (
                                  <p className="mt-1 text-sm text-red-600">
                                    {errors}
                                  </p>
                                )}
                              </div>

                              <div className="flex  space-x-2">
                                {leadStatusButton === "save" ? (
                                  <button
                                    onClick={handleSaveStatus}
                                    className="inline-flex justify-center py-2 px-4 w-auto border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                                  >
                                    Add
                                  </button>
                                ) : (
                                  <button
                                    onClick={handleUpdateStatus}
                                    className="inline-flex justify-center py-2 px-4 w-auto border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                                  >
                                    Update
                                  </button>
                                )}
                                <button
                                  type="button"
                                  onClick={() => setIsDialogOpen(false)}
                                  className="inline-flex justify-center py-2 px-4 w-auto border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-red-600 hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500"
                                >
                                  Cancel
                                </button>
                              </div>
                            </div>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </Dialog.Panel>
              </div>
            </div>
          </Dialog>
        )}




      {paginationDatasForLeadStatus && (
        <Pagination
          links={paginationDatasForLeadStatus.links}
          currentPage={paginationDatasForLeadStatus.current_page}
          totalResults={paginationDatasForLeadStatus.total}
          from={paginationDatasForLeadStatus.from}
          to={paginationDatasForLeadStatus.to}
          lastPage={paginationDatasForLeadStatus.last_page}
          onPageChange={handlePageChange}
        />
      )}
    </>
  );
}

export default StatusList;
